<template>
	<div class="col d-flex align-items-center justify-content-center flex-column">
		<div class="px-5 py-2 rounded-top-3 border-top border-start border-end border-1 border-white position-relative">
			<div class="p-3"></div>
			<div class="position-absolute w-100 h-100 start-0 top-0 rounded-top-2 py-1 d-flex align-items-center justify-content-center">
				<span class="text-white">{{name}}</span>
			</div>
		</div>
		<div class="bg-dark p-2 rounded-3">
			<div class="icon p-5 rounded-3 overflow-hidden" :style="{
				'background-image': `url(${icon})`
			}">
				<div class="p-4">
					<div class="p-2"></div>
				</div>
		</div>
		</div>
		<div class="px-5 py-2 rounded-bottom-3 border-bottom border-start border-end border-1 border-white position-relative">
			<div class="p-3"></div>
			<div class="position-absolute w-100 h-100 start-0 top-0 rounded-top-2 py-1 d-flex align-items-center justify-content-center flex-column">
				<small class="text-white fw-bold">{{rating}}</small>
				<small class="text-white">{{duration}}</small>
			</div>
		</div>
	</div>
</template>
<style scoped>
.icon {
	background-position: center;
	background-size: contain;
	background-repeat: no-repeat;
}
</style>
<script>
export default {
	name: "SkillComp",
	data(){
		return {}
	},
	props: {
		name: String,
		rating: String,
		duration: String,
		icon: String
	}
}
</script>